import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@pelckmans/elementis/components/dialog';
import Button from '@pelckmans/elementis/components/button';
import DownloadIcon from '@pelckmans/elementis/icons/download';

type Props = {
  downloadUrl?: string;
  onClose: () => void;
  onReload?: () => void;
  tags?: ReactNode;
  title: string;
  titleTooltip: string;
  showCloseLabelAsText?: boolean;
};

function MaterialDialogHeader({
  title,
  titleTooltip,
  downloadUrl,
  onClose,
  onReload,
  tags,
  showCloseLabelAsText = false,
}: Props) {
  const { t } = useTranslation();

  return (
    <Dialog.Header
      title={title}
      titleTooltip={titleTooltip}
      onClose={onClose}
      aria-label={t('ACTIONS.CLOSE')}
      buttonGroupProps={
        downloadUrl || onReload
          ? {
              'aria-label': undefined,
              role: undefined,
              children: (
                <>
                  {downloadUrl && (
                    <Button
                      prominence="neutral"
                      startIcon={<DownloadIcon data-testid="download-icon" />}
                      aria-label={t('ACTIONS.DOWNLOAD')}
                      title={t('ACTIONS.DOWNLOAD')}
                      as="link"
                      href={downloadUrl}
                      target="_blank"
                      key="download-button"
                    />
                  )}
                  {onReload && (
                    <Button prominence="neutral" onClick={onReload} key="reload-button">
                      {t('ACTIONS.RELOAD')}
                    </Button>
                  )}
                </>
              ),
            }
          : undefined
      }
      meta={tags}
      showCloseLabelAsText={showCloseLabelAsText}
    />
  );
}

export default MaterialDialogHeader;
